import React from 'react';

interface OnboardingTitleProps {
  text: string;
}

export default function OnboardingTitle({ text }: OnboardingTitleProps) {
  return <p className='text-xl font-medium text-black'>{text}</p>;
}
